import { connect } from 'react-redux';

// selectors
import { getActiveFieldUuid, getSelectedTrialPlacement, getActiveField } from 'current/selectors';
import { getBoundariesByFieldUuid } from 'boundaries/selectors';
import { isResourceTypeLoaded } from 'loading/selectors';
import { getTrialPlacementOptions } from '../trial-placements/selectors';
import { getPlantingPlanParams } from 'planting-plan-form/selectors';
import { getStepNumber } from 'script-flow/selectors';
import { getExperimentApplication } from './selectors';

// actions
import { setTrialPlacementOption } from 'current';

// components
import { resourceType } from '../constants/loading';
import TrialPlacementsLoader from './TrialPlacementsLoader';

export default connect(
  state => {
    const trialPlacementOptions = getTrialPlacementOptions(state);
    const fieldBoundary = getBoundariesByFieldUuid(state, getActiveFieldUuid(state));

    const options = [];
    for (const [key, value] of Object.entries(trialPlacementOptions)) {
      options.push({
        id: key,
        geoJson: {
          type: 'FeatureCollection',
          features: [
            { type: 'Feature', geometry: fieldBoundary, properties: 
              { name: 'field', area: getActiveField(state).area } },
            { type: 'Feature', geometry: value.zones.champion.geoJson, properties: 
              { name: 'champion', area: value.zones.champion.area } },
            { type: 'Feature', geometry: value.zones.challenger.geoJson, properties: 
              { name: 'challenger', area: value.zones.challenger.area } }
          ]
        }
      });
    }
    const plantingPlanParams = getPlantingPlanParams(state);

    return {
      stepNumber: getStepNumber(state),
      areTrialPlacementsLoaded: isResourceTypeLoaded({
        state,
        type: resourceType.EXPERIMENTS
      }),
      trialPlacementOptions: options,
      selectedTrialPlacementsId: getSelectedTrialPlacement(state),
      applicationRate: plantingPlanParams.applicationRate,
      field: getActiveField(state),
      fungicide: getExperimentApplication(state),
      plantingPlanParams
    };
  }, dispatch => ({
    onSelectTrialPlacements: id => {
      dispatch(setTrialPlacementOption(id));
    }
  })
)(TrialPlacementsLoader);
